import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DeviceData, DeviceType } from '../../../../../../../lib/device/device-detection.model';

@Component({
  selector: 'ifc-id-verse-standard-flow-section',
  templateUrl: './id-verse-standard-flow-section.component.html',
  styleUrls: ['./id-verse-standard-flow-section.component.scss'],
  standalone: false
})
export class IdVerseStandardFlowSectionComponent {
  @Input() verificationUrl: string;
  @Input() deviceData: DeviceData;
  @Input() headerLogoUrl: string;
  @Input() qrLogoUrl: string;
  @Output() continue = new EventEmitter<void>();

  readonly DeviceType = DeviceType;

  onClickContinue(): void {
    this.continue.emit();
  }
}
